export const BASE_URL = 'https://vrdentalbackend.vrdenta.com/api';